export default __webpack_public_path__ + "static/media/dick.8af5b751.jpg";